// Localização: frontend/src/hooks/data/usePacienteProntuario.js (versão 0.2.1)

import { useState, useEffect, useCallback } from 'react';
import { getProntuarioSummary } from '../../api/api'; // Certifique-se do caminho correto
import { calculateAge, formatDate } from '../../utils/formatters'; // Assumindo utilitário de formatação

/**
 * Hook para buscar os dados de resumo do prontuário de um paciente específico.
 * Utilizado para o cabeçalho e a aba de Visão Geral (Overview).
 * * @param {number} pacienteId - O ID do paciente.
 * @returns {object} { data, isLoading, error, refetch }
 */
export const usePacienteProntuario = (pacienteId) => {
    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchData = useCallback(async () => {
        if (!pacienteId) {
            setError("ID do paciente não fornecido.");
            setIsLoading(false);
            return;
        }

        setIsLoading(true);
        setError(null);
        
        try {
            const response = await getProntuarioSummary(pacienteId);

            // Adiciona campos formatados para uso no frontend (ex: idade no cabeçalho)
            const processedData = response.data.data;

            if (processedData.paciente) {
                processedData.paciente.idade = calculateAge(processedData.paciente.data_nascimento);
                processedData.paciente.data_nascimento_formatada = formatDate(processedData.paciente.data_nascimento);
            }

            setData(processedData);
        } catch (err) {
            console.error("Erro ao buscar resumo do prontuário:", err);
            // Assume que o erro de API vem em err.response.data.message ou fallback
            setError(err.response?.data?.message || "Não foi possível carregar o resumo do prontuário.");
        } finally {
            setIsLoading(false);
        }
    }, [pacienteId]); // A dependência garante que o fetch ocorra apenas quando o ID mudar

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return {
        data,
        isLoading,
        error,
        refetch: fetchData // Permite que os componentes acionem uma nova busca
    };
};